import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { EventsOnSaleActions } from './events-on-sale.actions';
import { EventWithVenue } from "../../models";
import { Observable } from "rxjs";
import { EventWithVenueSearchBox, Search } from "./event-with-venue-search-box";
import { LeoBox } from "../../ui-helper"
import { EventWithVenueList } from "./event-with-venue-list";
import { FilterListService, SortService } from "../../services";
import * as moment from "moment";
import { Location } from '@angular/common';

@Component({
	templateUrl: "./events-on-sale.html"
})
export class EventsOnSaleComponent {
	private eventsWithVenues$: Observable<EventWithVenue[]>;
	private orderBy$: Observable<string>;

	private search;
	private orderBy: string = "";
	private saleRoute: string = "/sale";
	private pageHeadline: string = "Veranstaltungen im Verkauf";
	private saleRouteSeatingplan: string = "/seatingplanSale"
	private boxOffice: boolean = false;

	constructor(
		private filterListService: FilterListService,
		private sortService: SortService,
		private store: Store<AppState>,
		private route: ActivatedRoute,
		private actions: EventsOnSaleActions,
		private router: Router,
		private location: Location
	) {}


	filterAndSearch =  (eventWithVenues: EventWithVenue[], search: Search, orderBy: string) => {
		let filteredList = eventWithVenues;
		if (search.eventTitle) {
			filteredList = this.filterListService.filterString(filteredList, 'title', search.eventTitle)
		}
		if (search.venueName) {
			filteredList = this.filterListService.filterString(filteredList, 'venueName', search.venueName)
		}

		const searchFrom = search.from && search.from !== "" ? search.from : null;
		const searchTo = search.to && search.to !== ""  ? search.to : null;

		if (searchFrom || searchTo) {
			filteredList = this.filterListService.filterMinMaxDate(filteredList, 'begin', 'begin', searchFrom, searchTo)
		}
		return this.sortService.sort(filteredList, orderBy)


	}
	searchChange(search) {
		this.search = search
		this.store.dispatch(this.actions.search(search))
	}
	orderByChange(order) {
		this.orderBy = order
		this.store.dispatch(this.actions.orderBy(order))
	}

	navigateToDetails(idsAndQuotaFlag: {eventId: number, seatingplanUuid: string, userSetHasVisualQuota: boolean}) {
		// damit auf der tickets kaufen seite der button 'zurück zur suche' korrekt funktionieren kann, muss die url mit den filter parametern
		// in der history vorhanden sein
		// daher wird die aktuelle Route plus filter parameter in die url gepushed (this.location.go(url))
		// bevor dann auf die tickets kaufen seite navigiert wird.
		const searchParams = {
			title: this.search.eventTitle,
			venue: this.search.venueName,
			from: this.search.from,
			to: this.search.to,
			sort: this.orderBy
		}
		const url = this.router.createUrlTree([], { relativeTo: this.route, queryParams: searchParams }).toString();
		this.location.go(url)
		// wenn der User ein Visuelles Kontingent für das Event gemeldet hat, dann zum SeatingplanSale/ box-office-seatingplan weiterleiten
		if (idsAndQuotaFlag.userSetHasVisualQuota) {
			this.router.navigate([this.saleRouteSeatingplan, searchParams, idsAndQuotaFlag.eventId])
		} else {
			// ansonsten zum normalen verkauf weiterleiten
			this.router.navigate([searchParams, idsAndQuotaFlag.eventId], { relativeTo: this.route })
		}
	}

	resetSearch() {
		this.search = {
					eventTitle: "",
					from: "",
					to: "",
					venueName: ""
				}
		this.orderBy = "begin"
		this.store.dispatch(this.actions.orderBy(this.orderBy))
		// replace router.navigate to change url on search reset
		// this.router.navigate([this.saleRoute])
		this.location.go(this.saleRoute)
	}

	ngOnInit() {
		this.route.data.subscribe((data) => {
			this.store.dispatch(this.actions.collectionLoaded(data["eventsOnSale"]));
			if (data.boxOffice) {
				this.boxOffice = data.boxOffice;
				this.pageHeadline = "Tageskasse";
				this.saleRoute = "box-office";
				// atm we do not need to redirect to sp-page, we navigate direct to box office
				// this.saleRouteSeatingplan = "seatingplan-sale-box-office";
				this.saleRouteSeatingplan = "box-office-seatingplan";
			}
		});

		let collection$ = this.store.select("eventsOnSale", "collection");
		let search$ = this.store.select("eventsOnSale", "search");
		this.orderBy$ = this.store.select("eventsOnSale", "order");

		this.eventsWithVenues$ = Observable.combineLatest(
			collection$,
			search$,
			this.orderBy$,
			this.filterAndSearch)

		this.route.params.subscribe(params => {
			if (params && Object.keys(params).length > 0) {
				this.search = {
					eventTitle: params["title"],
					from: params["from"],
					to: params["to"],
					venueName: params["venue"]
				}
				this.orderBy = params["sort"]
				this.store.dispatch(this.actions.orderBy(this.orderBy))
				this.store.dispatch(this.actions.search(this.search))
			} else {
				this.search = {
					eventTitle: "",
					from: this.boxOffice ? moment().startOf('day').format("YYYY-MM-DDTHH:mm:ss") : "",
					to: "",
					venueName: ""
				}
				this.orderBy = "begin"
				this.store.dispatch(this.actions.orderBy(this.orderBy))
				this.store.dispatch(this.actions.search(this.search))
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/app/components/events-on-sale/events-on-sale.component.ts